import AddCardManager from "@web/vpt-assets/assets/js/utilities/addCard/addCardManager";

export default class BookingPaymentConfigurator {

    constructor() {
        new AddCardManager({
            userWebStoreCardRequest: myApp.config.routing.userWebStoreCardRequest,
            executePaymentWithUserWebCardRequest: myApp.config.routing.executePaymentWithUserWebCardRequest,
        });

        this.eventDelegation();
    };

    eventDelegation() {
        const tpvRedsys = $('#tpv_redsys');
        tpvRedsys.on('load', () => {
            try {
                if (tpvRedsys.contents().find('[data-ok-tpv]').length > 0) {
                    tpvRedsys.hide();
                    window.location.href = okUrlRedirect;
                }
            } catch (err) {
            }
        });

        const buttonReactivateBooking = document.querySelector('button[data-send-form]');
        if (buttonReactivateBooking) {
            const buttonText = buttonReactivateBooking.childNodes[0].nodeValue;
            buttonReactivateBooking.addEventListener('click', (e) => {
                const currentTarget = e.currentTarget;
                currentTarget.querySelector('i').classList.remove('hide');
                currentTarget.childNodes[0].nodeValue = '';
            })
            const reactivateForm = document.querySelector('div' + buttonReactivateBooking.getAttribute('data-send-form'));
            if (reactivateForm) {
                reactivateForm.bind("DOMSubtreeModified", () => {
                    buttonReactivateBooking.querySelector('i').classList.add('hide');
                    buttonReactivateBooking.childNodes[0].nodeValue = buttonText;
                });
            }
        }
    }
}
